/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminExpertAddonDto } from './AdminExpertAddonDto';
import type { AdminExpertDocumentDto } from './AdminExpertDocumentDto';
import type { AdminExpertLocationDto } from './AdminExpertLocationDto';
import type { AdminExpertServiceDto } from './AdminExpertServiceDto';
import type { AdminExpertStatsDto } from './AdminExpertStatsDto';
import type { AdminExpertSubscriptionDto } from './AdminExpertSubscriptionDto';
import type { AdminExpertSuspensionDetailsDto } from './AdminExpertSuspensionDetailsDto';
export type AdminExpertDetailResponseData = {
    id: string;
    expertId: string;
    displayId: string;
    fullName: string;
    email?: Record<string, any> | null;
    phoneCountryCode?: Record<string, any> | null;
    phoneNumber?: Record<string, any> | null;
    gender?: Record<string, any> | null;
    dateOfBirth?: Record<string, any> | null;
    age?: Record<string, any> | null;
    profileImageUrl?: Record<string, any> | null;
    shortBio?: Record<string, any> | null;
    expertise?: Record<string, any> | null;
    modes?: Record<string, any> | null;
    yearsOfExperience?: Record<string, any> | null;
    educationLevel?: Record<string, any> | null;
    badgeLevel?: Record<string, any> | null;
    /**
     * Admin display label: Active | Hidden | Inactive | Suspended. Active requires verified + availability + (expert pricing OR active package) + accepting bookings.
     */
    accountStatus: string;
    /**
     * Admin display label: Pending upload | Pending review | Requested documents | Rejected | Verified. Derived from experts.verification_status and uploaded documents.
     */
    verificationStatus: string;
    dateJoined?: Record<string, any> | null;
    lastActiveAt?: Record<string, any> | null;
    /**
     * Whether a mobile login has been recorded (users.last_app_login_at). Independent of push notification consent. False means no mobile login on record, which is not proof the app was never installed.
     */
    appInstalled: boolean;
    /**
     * Last recorded mobile login, or null if none is on record.
     */
    appLastUsedAt: string | null;
    /**
     * Platform of the most recent push-registered device. Null when the expert has used the app but never granted notification permission, so appInstalled can be true while this is null.
     */
    appPlatform: AdminExpertDetailResponseData.appPlatform | null;
    /**
     * App build on that device. Null under the same conditions as appPlatform.
     */
    appVersion: string | null;
    /**
     * Which surface created the account. Note this defaults to app for anything not created through the web onboarding flow, so it reads as "not web onboarding" rather than as proof of an app signup.
     */
    signupPlatform: AdminExpertDetailResponseData.signupPlatform;
    isVerified: boolean;
    verifiedAt?: Record<string, any> | null;
    verifiedBy?: Record<string, any> | null;
    verificationNotes?: Record<string, any> | null;
    isFasttrackVerification: boolean;
    currentSubscription?: AdminExpertSubscriptionDto | null;
    stats: AdminExpertStatsDto;
    locations: Array<AdminExpertLocationDto>;
    services: Array<AdminExpertServiceDto>;
    documents: Array<AdminExpertDocumentDto>;
    suspensionDetails?: AdminExpertSuspensionDetailsDto | null;
    addons: Array<AdminExpertAddonDto>;
};
export namespace AdminExpertDetailResponseData {
    /**
     * Platform of the most recent push-registered device. Null when the expert has used the app but never granted notification permission, so appInstalled can be true while this is null.
     */
    export enum appPlatform {
        IOS = 'ios',
        ANDROID = 'android',
        WEB = 'web',
    }
    /**
     * Which surface created the account. Note this defaults to app for anything not created through the web onboarding flow, so it reads as "not web onboarding" rather than as proof of an app signup.
     */
    export enum signupPlatform {
        APP = 'app',
        WEB = 'web',
    }
}

